import React, { useState, useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import { IS_ADMIN } from '../../../utils/role';
import { useTranslation } from 'react-i18next';
import { useApproveInvoiceMutation } from '../../../store/invoices/invoices.api';
import { InvoiceDto } from '../../../models/invoice.dto';
import { UserDto } from '../../../models/user.dto';
import RejectDialog from '../invoices-list-item/reject-dialog/reject-dialog';
import './action-dropdown.scss';

interface PropsType {
   invoice: InvoiceDto;
   user?: UserDto;
}

const StatusDropdown = ({ invoice, user } : PropsType) => {
   const [showRejectModal, setShowRejectModal] = useState(false);
   const isAdmin = IS_ADMIN();

   const [approveInvoice] = useApproveInvoiceMutation();
   const [translate] = useTranslation(['common', 'invoice']);

   const activeRejections =  invoice.rejections.filter(i => i.active);
   const approvedByUser = invoice.approvals.some((a) => a.active && a.email === user?.email);
   const rejectedByUser = activeRejections.some((r) => r.email == user?.email);

   const isRejected = invoice.rejections?.length > 0;
   const isApproved = invoice.approvals?.length > 0;

   const onClickApprove = () => approveInvoice({ invoiceId: invoice.invoiceId });

   const dropdownItems = useMemo(() => {
      if (!isAdmin) return [];

      return [
         { 
            id: 'approve', 
            label: translate('invoice:invoice.approve'),
            disabled: !!activeRejections?.length || approvedByUser,
            action: onClickApprove
         },
         { 
            id: 'reject', 
            label: translate('invoice:invoice.reject'),
            disabled: rejectedByUser,
            action: () => setShowRejectModal(true)
         }
      ];
   }, [activeRejections, approvedByUser, rejectedByUser]);


   const getStatusItem = () => {
      if (isRejected) {
         return <span>{translate('common:common.status.rejected')}</span>
      } else if (isApproved) {
         return <span>{translate('common:common.status.approved')}</span>
      } else {
         return <span>{translate('common:common.status.pending')}</span>
      }
   }

   const getStatusStyle = () => {
      if (isRejected) {
         return 'status-rejected';
      } else if (isApproved) {
         return 'status-approved';
      } else {
         return 'status-pending';
      }
   }

   return (
      <>
         <Dropdown className="actions">
            <Dropdown.Toggle className={`toggle-menu-button ${getStatusStyle()}`}>
               {getStatusItem()}
            </Dropdown.Toggle>
            {IS_ADMIN() && (
               <Dropdown.Menu>
                  {dropdownItems.map((item) => (
                     <Dropdown.Item
                        key={item.id}
                        onClick={() => {
                           if (!item.disabled) item.action();
                        }}
                        disabled={item.disabled}
                        style={{ width: 276, boxSizing: 'border-box'}}
                     >
                        {item.label}
                     </Dropdown.Item>
                  ))}
               </Dropdown.Menu>
            )}
         </Dropdown>
         <RejectDialog
            invoiceId={invoice.invoiceId}
            show={showRejectModal}
            onHide={() => setShowRejectModal(false)}
            theme={'dark'}
         />
      </>
   );
};

export default StatusDropdown;
